export const getLocaleData = (lang: string, az: any, en: any, ru: any) => {
  return lang === 'az' ? az : lang === 'en' ? en : ru;
};
